(() => {
  if (window.olmaHausInitialized) return;
  window.olmaHausInitialized = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-oh-topic]');
    if (link) {
      const select = document.querySelector('[data-oh-contact-topic]');
      if (select && Array.from(select.options).some(option => option.value === link.dataset.ohTopic)) {
        select.value = link.dataset.ohTopic;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    const navLink = event.target.closest('.oh-mobile-nav__links a');
    if (navLink) navLink.closest('details').open = false;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.oh-mobile-nav[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
  document.addEventListener('shopify:block:select', (event) => {
    const details = event.target.querySelector('.oh-offer__details');
    if (details) details.open = true;
  });
})();

if (!customElements.get('olma-publication')) {
  customElements.define('olma-publication', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-press-open]');
      if (!this.dialog || !this.opener) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.opener.addEventListener('click', () => this.open(), options);
      this.querySelector('[data-press-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => {
        this.unlockScroll();
        if (this.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
          this.dialog.close();
        }
      }, options);
      this.addEventListener('shopify:block:select', event => {
        this.open();
        event.target.scrollIntoView({ block: 'nearest', behavior: 'instant' });
      }, options);
      document.addEventListener('shopify:section:deselect', event => {
        if (event.target.contains(this) && this.dialog.open) this.dialog.close();
      }, options);
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      this.dialog.scrollTop = 0;
      this.previousOverflow = document.body.style.overflow;
      this.scrollLocked = true;
      document.body.style.overflow = 'hidden';
    }

    unlockScroll() {
      if (!this.scrollLocked) return;
      document.body.style.overflow = this.previousOverflow;
      this.scrollLocked = false;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.unlockScroll();
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
